import React from "react";
import {useTranslation} from "react-i18next";
import {Space, Typography} from "antd";
import {Link} from "react-router-dom";
import {ComponentPropsFromRoute} from "../../../routers/routers";
import {RouteTabs} from "../../common/route-tabs/route.tabs";

export const ProductionRequestListWrapper: React.FC<ComponentPropsFromRoute> = ({name, routeChildren}) => {

    const {t} = useTranslation("translation", {useSuspense: false});

    return (
        <div className="page_content">
            <Space direction="vertical">
                <Typography.Title level={3}>
                    {t("PRODUCTION_REQUEST.LIST.TITLE")}
                </Typography.Title>
                <RouteTabs routes={routeChildren!} />
            </Space>
        </div>
    );
}
